<script setup lang="ts">
import type { FollowButtonProps } from "~/types/FollowButton";

const props = defineProps<FollowButtonProps>();

defineEmits<{
  (e: "click"): void;
}>();

const platformStore = usePlatformStore();
</script>

<template>
  <FollowButtonFTG
    v-if="platformStore.isFrameTheGame"
    v-bind="props"
    @click="$emit('click')"
  />
  <FollowButtonMWS
    v-else
    v-bind="props"
    @click="$emit('click')"
  />
</template>
